import { Samples } from '@df/samples/samples';
import { SamplesBasket } from '@df/samples/samples-basket';
import { IAddToBasketRequestData } from '@df/session/api/basket/basket.service';

declare module '@df/checkout/checkout.interfaces' {
    namespace Checkout {
        interface IData {
            isSamples?: boolean;
        }
    }
}

declare module '@df/catalog/product/product' {
    interface IProductDataV2 {
        sample?: number;
    }
}

declare module '@df/session/api/customer' {
    interface Customer {
        samplesBasket: SamplesBasket;
        samples: Samples;
    }
}

export namespace NSamples {
    export const SAMPLE_QUOTE_SUFFIX = '?sampleQuote=1';

    export const ENDPOINTS = {
        remove: 'basket/remove' + SAMPLE_QUOTE_SUFFIX,
        checkoutRemove: 'checkout/remove' + SAMPLE_QUOTE_SUFFIX,
        createQuote: 'samples/submit' + SAMPLE_QUOTE_SUFFIX,
        loadQuote: 'samples/load' + SAMPLE_QUOTE_SUFFIX,
        checkoutData: 'checkout/load' + SAMPLE_QUOTE_SUFFIX,
        checkoutSuccessData: 'checkout/success' + SAMPLE_QUOTE_SUFFIX
    };

    export interface IConfig {
        // if true then will add sampled product to wishlist on add
        toWishlist?: boolean;
        limit?: number;
        checkoutUrl: string;
        checkoutSuccesUrl: string;
        checkoutErrorUrl: string;
    }

    export interface IDataItem {
        productId: number;
    }

    export interface ISamplesAddToBasketRequestData extends IAddToBasketRequestData {
        sampleQuote?: true;
    }

    export interface ISampleData {}

    export const DEFAULT_CONFIG: Partial<IConfig> = {
        toWishlist: false,
        checkoutUrl: '/sample-checkout',
        checkoutErrorUrl: '/',
        checkoutSuccesUrl: '/sample-checkout/success'
    };
}
